export const SET_FINAL_CONFIRMATION = 'SET_FINAL_CONFIRMATION';
export const SET_FINAL_CONFIRMATION_SUCCESS = 'SET_FINAL_CONFIRMATION_SUCCESS';
export const SET_FINAL_CONFIRMATION_FAILURE = 'SET_FINAL_CONFIRMATION_FAILURE';


export const TRANSFER_LEAD_TO_BIKE = 'TRANSFER_LEAD_TO_BIKE';
export const TRANSFER_LEAD_TO_BIKE_SUCCESS = 'TRANSFER_LEAD_TO_BIKE_SUCCESS';
export const TRANSFER_LEAD_TO_BIKE_FAILURE = 'TRANSFER_LEAD_TO_BIKE_FAILURE';



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/constants/final_confirmation.constants.js